import React from 'react'
import { useIntl } from 'react-intl'

import BuyNowCta from '@/components/BuyNowCta'
import CompareTable from '@/components/blocks/CompareTable'
import ProductHeader from '@/components/sections/ProductHeader'
import TextImageRow from '@/components/sections/TextImageRow'
import { Column, Layout, Row, Section } from '@/components/layout'
import { Text } from '@/components/common'
import scheduleTraining from '@/assets/vip-service/schedule-training.png'
import dedicatedSupport from '@/assets/vip-service/support-team.png'
import exclusiveOffers from '@/assets/vip-service/exclusive-offers.png'
import welcomeEmail from '@/assets/vip-service/welcome-email.png'

const pageId = 'vipService'
export default function VipService() {
  const { formatMessage } = useIntl()
  const getPageMessage = (id) => formatMessage({ id: `pages.${pageId}.${id}` })

  const getPageObject = (id) => {
    // This could be using your localization library or a simple object lookup
    const messages = {
      scheduleTrainingList: {
        item1: '(2) 30-minute 1:1 trainings per month',
        item2: 'Experts are available M-F, 9:00am-6:00pm EST',
      },
    }
    return messages[id] || {} // Return an empty object if the message is not found
  }

  return (
    <Layout.Content>

      <ProductHeader
        cta={{ sku: 'neatvipyr' }}
        smallPrint="VIP Service cannot be purchased without a Neat subscription."
        subtitle="Dedicated and priority support so you don’t have to worry about a thing."
        title="VIP Service"
      />

      <Section>
        <Text.H2 brandPrimary center style={{ marginBottom: '40px' }}>VIP Service Features</Text.H2>

        <TextImageRow
          image={scheduleTraining}
          listItems={getPageObject('scheduleTrainingList')}
          text={getPageMessage('features.scheduleTraining')}
          title="Schedule 1:1 training"
        />

        <TextImageRow
          image={dedicatedSupport}
          reverse
          text={getPageMessage('features.supportTeam')}
          title="Dedicated Support Team"
        />

        <TextImageRow
          image={exclusiveOffers}
          text={getPageMessage('features.exclusiveOffers')}
          title="Exclusive offers"
        />

        <TextImageRow
          image={welcomeEmail}
          reverse
          text={getPageMessage('features.welcomeEmail')}
          title="Welcome email"
        />
      </Section>

      <Section>
        <Text.H2 brandPrimary center>Standard Support vs VIP Service</Text.H2>
        <div className="max-w-900">
          <Row>
            <Column fill>
              <CompareTable />
            </Column>
          </Row>
        </div>

      </Section>

      <Section>
        <Text.H2 center>Easy and efficient - now that&apos;s Neat!</Text.H2>
        <BuyNowCta sku="neatvipyr" style={{ border: '0' }} />
        <Text center size="xsmall">VIP Service cannot be purchased without a Neat subscription.</Text>
      </Section>

    </Layout.Content>
  )
}

VipService.layoutProps = {
  pageId,
}
